import { createSelector } from 'reselect';
import { prop, isNil, compose, map, reject, propOr } from 'ramda';
import { selectAllExperiences, selectKioskModes } from '../contentRegistry';
import { ROUTES } from '../../routes/routes';

export const selectKioskDomain = state => state.kiosk;

export const selectCurrentKioskId = createSelector(
  selectKioskDomain,
  prop('currentKioskId')
);

export const selectIsKioskMode = createSelector(
  selectKioskDomain,
  prop('isKioskMode')
);

export const selectCurrentKioskData = createSelector(
  selectCurrentKioskId,
  selectKioskModes,
  prop
);

export const selectCurrentKioskName = createSelector(
  selectCurrentKioskData,
  prop('name')
);

export const selectCurrentKioskSlug = createSelector(
  selectCurrentKioskData,
  prop('slug')
);

export const selectCurrentKioskExperiencesIds = createSelector(
  selectCurrentKioskData,
  propOr([], 'experiences')
);

export const selectCurrentKioskExperiences = createSelector(
  selectCurrentKioskExperiencesIds,
  selectAllExperiences,
  (kioskExperiences, allExperiences) =>
    compose(
      reject(isNil),
      map(id => allExperiences[id])
    )(kioskExperiences)
);

export const selectCurrentKioskHomeRoute = createSelector(
  selectCurrentKioskData,
  ({ slug } = {}) => ROUTES.kiosk(slug)
);
